module.exports = __webpack_public_path__ + "img/pin-icon.2843a064.svg";